import React, { useState } from "react";

export default function Footer() {
  const [email, setEmail] = useState("");

  const handleSubmit = (event) => {
    alert(`Subscription request sent for: ${email}`);
  };

  return (
    <>
      <footer id="footer" class="footer">
        <div class="footer-newsletter">
          <div class="container">
            <div class="row justify-content-center text-center">
              <div class="col-lg-6">
                <h4>Join Our Newsletter</h4>
                <p>
                  Subscribe to our newsletter and receive the latest news about
                  our products and services!
                </p>
                <form class="php-email-form">
                  <div class="newsletter-form">
                    <input type="email" name="email" />
                    <a
                      className="btn btn-primary rounded-pill"
                      onClick={handleSubmit}
                    >
                      {" "}
                      Subscribe
                    </a>
                  </div>
                  <div class="loading">Loading</div>
                  <div class="error-message"></div>
                  <div class="sent-message">
                    Your subscription request has been sent. Thank you!
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="container footer-top">
          <div class="row gy-4">
            <div class="col-lg-4 col-md-6 footer-about">
              <a href="/" class="d-flex align-items-center">
                <span class="sitename">Peduli TBC</span>
              </a>
              <div class="footer-contact pt-3">
                <p>Jawa Tengah</p>
                <p>Indonesia</p>
                <p class="mt-3">
                  <strong>Phone:</strong> <span>083838612764</span>
                </p>
                <p>
                  <strong>Email:</strong> <span>sydigital.id@gmail.com</span>
                </p>
              </div>
            </div>

            <div class="col-lg-2 col-md-3 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i class="bi bi-chevron-right"></i> <a href="#">Home</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i> <a href="#">About us</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i> <a href="#">Services</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>{" "}
                  <a href="#">Terms of service</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-2 col-md-3 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i class="bi bi-chevron-right"></i> <a href="#">Web Design</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>{" "}
                  <a href="#">Web Development</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i>{" "}
                  <a href="#">Product Management</a>
                </li>
                <li>
                  <i class="bi bi-chevron-right"></i> <a href="#">Marketing</a>
                </li>
              </ul>
            </div>

            <div class="col-lg-4 col-md-12">
              <h4>Ikuti Kami</h4>
              <p>
                Ikuti kami di media sosial untuk mendapatkan informasi terbaru
                tentang kami.
              </p>
              <div class="social-links d-flex">
                <a href="">
                  <i class="bi bi-twitter-x"></i>
                </a>
                <a href="">
                  <i class="bi bi-facebook"></i>
                </a>
                <a href="">
                  <i class="bi bi-instagram"></i>
                </a>
                <a href="">
                  <i class="bi bi-linkedin"></i>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="container copyright text-center mt-4">
          <p>
            © <span>Copyright</span>{" "}
            <strong class="px-1 sitename">Peduli TBC</strong>{" "}
            <span>All Rights Reserved</span>
          </p>
          <div class="credits">
            Created by <a href="/">SidigiCode</a> x <a href="/">TIM KKN IBN </a>
          </div>
        </div>
      </footer>

      <a
        href="#"
        id="scroll-top"
        class="scroll-top d-flex align-items-center justify-content-center"
      >
        <i class="bi bi-arrow-up-short"></i>
      </a>
    </>
  );
}
